export default __webpack_public_path__ + "static/media/sakura-no-1.68fe6d37.ogg";